import { provide, inject } from 'vue-demi';

function createContainer(useComposition) {
    var providerSymbol;
    function provide$1(props) {
        providerSymbol = Symbol();
        var value = useComposition(props && props.initialState);
        provide(providerSymbol, value);
        return value;
    }
    function useContainer() {
        var value = inject(providerSymbol);
        if (!value) {
            throw new Error('Container must be used in provided Component.');
        }
        return value;
    }
    return { provide: provide$1, useContainer: useContainer };
}

export { createContainer };
